module.exports = __webpack_public_path__ + "img/book-stroke.dcd951fd.png";